import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useLang } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { navItems } from "../components/Layout";
import { PageHeader } from "../components/common";

export default function More() {
  const { t } = useLang();
  const { can, user, logout } = useAuth();
  return (
    <>
      <PageHeader title={t("Menu", "Menú")} subtitle={`${user.name} · ${user.email}`} />
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {navItems(t, can, user.role, user.platform_admin).map((n) => (
          <Link key={n.to} to={n.to} className="card flex flex-col gap-3 p-4 min-h-[96px] font-bold hover:border-[#D9531E] active:scale-[0.98] transition-transform" data-testid={`more-${n.id}-link`}>
            <n.icon className="w-6 h-6 text-[#D9531E]" /> {n.label}
          </Link>
        ))}
      </div>
      <button className="btn-outline w-full mt-6" onClick={logout} data-testid="more-logout-btn"><LogOut className="w-5 h-5" /> {t("Log out", "Cerrar sesión")}</button>
    </>
  );
}
